/* tslint:disable */
/* eslint-disable */
/**
 * Address Zara public REST API
 * This API defines the operations on addresses that the adapter will include. The purpose of this API is to serve as an intermediary between the clients that used the legacy address API and the new Meccano address API
 *
 * The version of the OpenAPI document: 1.19.0
 * Contact: LddEcommerceZaraCustomerBack@inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddUpdateAddressRequest
 */
export interface AddUpdateAddressRequest {
    /**
     * 
     * @type {Address}
     * @memberof AddUpdateAddressRequest
     */
    'billingAddress'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof AddUpdateAddressRequest
     */
    'shippingAddress'?: Address;
    /**
     * 
     * @type {PrivacyPolicyBundleRequest}
     * @memberof AddUpdateAddressRequest
     */
    'privacyPolicyBundle'?: PrivacyPolicyBundleRequest;
}
/**
 * Returns the unique identification for the address registered or updated. Depending on the type of address the value will be setter in *billingAddressId* or *shippingAddressId*
 * @export
 * @interface AddUpdateAddressResponse
 */
export interface AddUpdateAddressResponse {
    /**
     * 
     * @type {number}
     * @memberof AddUpdateAddressResponse
     */
    'billingAddressId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddUpdateAddressResponse
     */
    'shippingAddressId'?: number;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * Unique identificator of the address in the system. In case of registering an address this field must be missing.
     * @type {number}
     * @memberof Address
     */
    'id'?: number;
    /**
     * Flag that indicates that the adress will be used for billing purpouses. It could also be used for shipping. Users can only have one active billing address in theirs addressbook.
     * @type {boolean}
     * @memberof Address
     */
    'isBilling'?: boolean;
    /**
     * This is a backwards compatibility field, not used at this time.
     * @type {boolean}
     * @memberof Address
     * @deprecated
     */
    'isPrimary'?: boolean;
    /**
     * Flag that indicates that this is the primary address for the user. Only one address can be primary at a time.
     * @type {boolean}
     * @memberof Address
     */
    'isPreferred'?: boolean;
    /**
     * Unique identifier of the address within the address book. The system generates this value in natural language when the address is registered. Deprecated field.
     * @type {string}
     * @memberof Address
     */
    'nickName'?: string;
    /**
     * 
     * @type {Company}
     * @memberof Address
     */
    'company'?: Company;
    /**
     * Email contact of the user.
     * @type {string}
     * @memberof Address
     */
    'email'?: string;
    /**
     * First name of the user.
     * @type {string}
     * @memberof Address
     */
    'firstName'?: string;
    /**
     * Middle name of the user.
     * @type {string}
     * @memberof Address
     */
    'middleName'?: string;
    /**
     * Last name of the user.
     * @type {string}
     * @memberof Address
     */
    'lastName'?: string;
    /**
     * Stores the part of the address filled by the user manually. Street name, number, floor, door and so, this is the kind of information that should be used. Only two address lines could be used and at least one is required.
     * @type {Array<string>}
     * @memberof Address
     */
    'addressLines'?: Array<string>;
    /**
     * Second level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof Address
     */
    'city'?: string;
    /**
     * Second level of geopolitical subdivisions identifier. Some countries does not have elements at this level.
     * @type {string}
     * @memberof Address
     */
    'cityCode'?: string;
    /**
     * Third level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof Address
     */
    'district'?: string;
    /**
     * Third level of geopolitical subdivisions identifier. Some countries does not have elements at this level.
     * @type {string}
     * @memberof Address
     */
    'districtCode'?: string;
    /**
     * First level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof Address
     */
    'state'?: string;
    /**
     * First level of geopolitical subdivisions identifier. Some countries does not have elements at this level.
     * @type {string}
     * @memberof Address
     */
    'stateCode'?: string;
    /**
     * Fourth level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof Address
     */
    'municipality'?: string;
    /**
     * Fourth level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof Address
     */
    'neighborhood'?: string;
    /**
     * Country name in natural language.
     * @type {string}
     * @memberof Address
     */
    'country'?: string;
    /**
     * ISO 3166-1 alpha-2 two letter country code.
     * @type {string}
     * @memberof Address
     */
    'countryCode'?: string;
    /**
     * Zipcode of the address.
     * @type {string}
     * @memberof Address
     */
    'zipCode'?: string;
    /**
     * List of phone numbers registered by the user. Only two phone numbers could be used.
     * @type {Array<Phone>}
     * @memberof Address
     */
    'phones'?: Array<Phone>;
    /**
     * 
     * @type {PickUpPoint}
     * @memberof Address
     */
    'pickUpPoint'?: PickUpPoint;
    /**
     * Indicates the type of address and could take two values * address - when the address is registered by the user. * pickuppoint - when the address is selected as a pickup point selected from available points offered by the system. 
     * @type {string}
     * @memberof Address
     */
    'kind'?: string;
    /**
     * Name of the government issued identification document type.
     * @type {string}
     * @memberof Address
     */
    'documentType'?: string;
    /**
     * Id of the document type
     * @type {string}
     * @memberof Address
     */
    'documentTypeCode'?: string;
    /**
     * Government issued personal identification.
     * @type {string}
     * @memberof Address
     */
    'nif'?: string;
    /**
     * Name of the tax regime selected by the user.
     * @type {string}
     * @memberof Address
     */
    'taxRegime'?: string;
    /**
     * Id of the Tax Regime
     * @type {string}
     * @memberof Address
     */
    'taxRegimeCode'?: string;
    /**
     * Name of the tax code selected by the user. Although this taxCode could be nested into a parent taxCode only the value of the child taxCode will be returned.
     * @type {string}
     * @memberof Address
     */
    'taxCode'?: string;
    /**
     * Id of the Tax Code
     * @type {string}
     * @memberof Address
     */
    'taxCodeCode'?: string;
    /**
     * Flag that indicates that the client has given the consent to receive sms about shipping tracking when delivering to the address.
     * @type {boolean}
     * @memberof Address
     */
    'smsConsent'?: boolean;
    /**
     * In case actived in country configuration, this field stores the street number
     * @type {string}
     * @memberof Address
     */
    'streetNumber'?: string;
    /**
     * Government issued registration number.
     * @type {string}
     * @memberof Address
     */
    'registrationNumber'?: string;
    /**
     * Indicates the type of address and could take two values * address - Default value. Indicates the address is registered by the user. * dropPointDelivery -  
     * @type {string}
     * @memberof Address
     */
    'datatype'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'isAnonymized'?: boolean;
    /**
     * Some mandatory attributes of the address are missing. They must be filled and updated before the address could be used.
     * @type {boolean}
     * @memberof Address
     */
    'isIncomplete'?: boolean;
    /**
     * 
     * @type {AddressEvaluation}
     * @memberof Address
     */
    'addressEvaluation'?: AddressEvaluation;
}
/**
 * 
 * @export
 * @interface AddressBookResponse
 */
export interface AddressBookResponse {
    /**
     * 
     * @type {Array<Address>}
     * @memberof AddressBookResponse
     */
    'addresses'?: Array<Address>;
}
/**
 * Contains the address evaluation information
 * @export
 * @interface AddressEvaluation
 */
export interface AddressEvaluation {
    /**
     * The date when the address was last evaluated
     * @type {number}
     * @memberof AddressEvaluation
     */
    'evaluationDate'?: number;
    /**
     * 
     * @type {UserChoice}
     * @memberof AddressEvaluation
     */
    'userChoice'?: UserChoice;
    /**
     * Indicates wether the address is valid or not, simplifying the information provided by userChoice attribute.
     * @type {boolean}
     * @memberof AddressEvaluation
     */
    'isValid'?: boolean;
}


/**
 * The evaluation can provide the following results * VALID -> The address is validated successfully by transport service and there are no suggestions * VALID_WITH_SUGGESTIONS -> The address is validated successfully by transport service but there are some suggestions * NOT_VALID_WITH_SUGGESTIONS -> The address is not validated by transport service and there are some suggestions * NOT_VALID -> The address is not validated by transport service and there are no suggestions * NOT_AVAILABLE -> The transport service is not available or crashed 
 * @export
 * @enum {string}
 */

export const AddressEvaluationPassMark = {
    Valid: 'VALID',
    ValidWithSuggestions: 'VALID_WITH_SUGGESTIONS',
    NotValidWithSuggestions: 'NOT_VALID_WITH_SUGGESTIONS',
    NotValid: 'NOT_VALID',
    NotAvailable: 'NOT_AVAILABLE'
} as const;

export type AddressEvaluationPassMark = typeof AddressEvaluationPassMark[keyof typeof AddressEvaluationPassMark];


/**
 * Contains the types of address validations * TRANSPORT - Validate the address using the transport service. 
 * @export
 * @enum {string}
 */

export const AddressValidationType = {
    Transport: 'TRANSPORT'
} as const;

export type AddressValidationType = typeof AddressValidationType[keyof typeof AddressValidationType];


/**
 * In case the user is registered as a company, this entity stores information about it.
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * VAT identification number.
     * @type {string}
     * @memberof Company
     */
    'vatin'?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'name'?: string;
    /**
     * Government issued company registration number.
     * @type {string}
     * @memberof Company
     */
    'registrationNumber'?: string;
    /**
     * Email address legally certified by a government institution.
     * @type {string}
     * @memberof Company
     */
    'certifiedElectronicMail'?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'stateRegistration'?: string;
    /**
     * Name of the VAT identification number document type.
     * @type {string}
     * @memberof Company
     */
    'documentType'?: string;
    /**
     * Id of the document type
     * @type {string}
     * @memberof Company
     */
    'documentTypeCode'?: string;
}
/**
 * 
 * @export
 * @interface CopyAddressFromRequest
 */
export interface CopyAddressFromRequest {
    /**
     * address to be changed
     * @type {number}
     * @memberof CopyAddressFromRequest
     */
    'toAddressId'?: number;
    /**
     * address that will provide the data to be modified
     * @type {number}
     * @memberof CopyAddressFromRequest
     */
    'fromAddressId'?: number;
}
/**
 * 
 * @export
 * @interface CopyAddressResponse
 */
export interface CopyAddressResponse {
    /**
     * Identifier of the just created address.
     * @type {number}
     * @memberof CopyAddressResponse
     */
    'addressId'?: number;
}
/**
 * Extra parameters asocciated to a pickup point
 * @export
 * @interface DropPointExtraParam
 */
export interface DropPointExtraParam {
    /**
     * Name of the parameter.
     * @type {string}
     * @memberof DropPointExtraParam
     */
    'kind'?: string;
    /**
     * Regular expression that validates the value of the parameter.
     * @type {string}
     * @memberof DropPointExtraParam
     */
    'validRegexp'?: string;
    /**
     * Value of the parameter
     * @type {string}
     * @memberof DropPointExtraParam
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface EvaluateAddressRequest
 */
export interface EvaluateAddressRequest {
    /**
     * 
     * @type {Address}
     * @memberof EvaluateAddressRequest
     */
    'billingAddress'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof EvaluateAddressRequest
     */
    'shippingAddress'?: Address;
}
/**
 * Returns the result of the evaluation, that is, whether the address requested is valid or not and suggestions, if available.
 * @export
 * @interface EvaluateAddressResponse
 */
export interface EvaluateAddressResponse {
    /**
     * 
     * @type {AddressEvaluationPassMark}
     * @memberof EvaluateAddressResponse
     */
    'passMark'?: AddressEvaluationPassMark;
    /**
     * A list (may be empty) containing the suggested addresses
     * @type {Array<Address>}
     * @memberof EvaluateAddressResponse
     */
    'suggestions'?: Array<Address>;
}


/**
 * 
 * @export
 * @interface IntegrationAddress
 */
export interface IntegrationAddress {
    /**
     * Unique identificator of the address in the system. In case of registering an address this field must be missing.
     * @type {number}
     * @memberof IntegrationAddress
     */
    'id'?: number;
    /**
     * Unique identifier assigned at creation (identifier of the first snapshot).
     * @type {number}
     * @memberof IntegrationAddress
     */
    'inheritanceId'?: number;
    /**
     * Unique identifier of the user that owns the address.
     * @type {number}
     * @memberof IntegrationAddress
     */
    'userId'?: number;
    /**
     * Flag that indicates that the adress will be used for billing purpouses. It could also be used for shipping. Users can only have one active billing address in theirs addressbook.
     * @type {boolean}
     * @memberof IntegrationAddress
     */
    'isBilling'?: boolean;
    /**
     * Flag that indicates that the adress will be used for shipping purpouses.
     * @type {boolean}
     * @memberof IntegrationAddress
     */
    'isShippingAddress'?: boolean;
    /**
     * This is a backwards compatibility field, not used at this time.
     * @type {boolean}
     * @memberof IntegrationAddress
     * @deprecated
     */
    'primaryAddress'?: boolean;
    /**
     * 
     * @type {IntegrationCompany}
     * @memberof IntegrationAddress
     */
    'company'?: IntegrationCompany;
    /**
     * Email contact of the user.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'email'?: string;
    /**
     * First name of the user.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'firstName'?: string;
    /**
     * Middle name of the user.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'middleName'?: string;
    /**
     * Last name of the user.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'lastName'?: string;
    /**
     * Stores the part of the address filled by the user manually. Street name, number, floor, door and so, this is the kind of information that should be used. Only two address lines could be used and at least one is required.
     * @type {Array<string>}
     * @memberof IntegrationAddress
     */
    'addressLines'?: Array<string>;
    /**
     * Second level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'city'?: string;
    /**
     * Second level of geopolitical subdivisions identifier. Some countries does not have elements at this level.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'cityCode'?: string;
    /**
     * Third level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'district'?: string;
    /**
     * Third level of geopolitical subdivisions identifier. Some countries does not have elements at this level.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'districtCode'?: string;
    /**
     * First level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'state'?: string;
    /**
     * First level of geopolitical subdivisions identifier. Some countries does not have elements at this level.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'stateCode'?: string;
    /**
     * Fourth level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'municipality'?: string;
    /**
     * Fourth level of geopolitical subdivisions name in natural language. Some countries does not have elements at this level.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'colony'?: string;
    /**
     * Country name in natural language.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'countryName'?: string;
    /**
     * ISO 3166-1 alpha-2 two letter country code.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'countryCode'?: string;
    /**
     * Zipcode of the address.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'zipCode'?: string;
    /**
     * Street name.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'streetName'?: string;
    /**
     * Digital code for opening the customer front gate.
     * @type {string}
     * @memberof IntegrationAddress
     */
    'digiCode'?: string;
    /**
     * List of phone numbers registered by the user. Only two phone numbers could be used.
     * @type {Array<IntegrationPhone>}
     * @memberof IntegrationAddress
     */
    'phones'?: Array<IntegrationPhone>;
    /**
     * Identifier in natural language for this address.
     * @type {string}
     * @memberof IntegrationAddress
     * @deprecated
     */
    'addressName'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     * @deprecated
     */
    'birthdate'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     * @deprecated
     */
    'gender'?: string;
    /**
     * Some mandatory attributes of the address are missing. They must be filled and updated before the address could be used.
     * @type {boolean}
     * @memberof IntegrationAddress
     */
    'isIncomplete'?: boolean;
    /**
     * 
     * @type {IntegrationIdentificationDocument}
     * @memberof IntegrationAddress
     */
    'identificationDocument'?: IntegrationIdentificationDocument;
    /**
     * 
     * @type {IntegrationTaxRegime}
     * @memberof IntegrationAddress
     */
    'taxRegime'?: IntegrationTaxRegime;
    /**
     * 
     * @type {IntegrationTaxCode}
     * @memberof IntegrationAddress
     */
    'taxCode'?: IntegrationTaxCode;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {AddressEvaluation}
     * @memberof IntegrationAddress
     */
    'addressEvaluation'?: AddressEvaluation;
}
/**
 * In case the user is registered as a company, this entity stores information about it.
 * @export
 * @interface IntegrationCompany
 */
export interface IntegrationCompany {
    /**
     * VAT identification number. This will also be mapped to identificationDocument.value.
     * @type {string}
     * @memberof IntegrationCompany
     * @deprecated
     */
    'vatin'?: string;
    /**
     * Government issued registration number.
     * @type {string}
     * @memberof IntegrationCompany
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCompany
     */
    'taxOffice'?: string;
    /**
     * Government issued company registration number.
     * @type {string}
     * @memberof IntegrationCompany
     */
    'registrationNumber'?: string;
    /**
     * Email address legally certified by a government institution.
     * @type {string}
     * @memberof IntegrationCompany
     */
    'certifiedElectronicMail'?: string;
    /**
     * 
     * @type {IntegrationIdentificationDocument}
     * @memberof IntegrationCompany
     */
    'identificationDocument'?: IntegrationIdentificationDocument;
}
/**
 * 
 * @export
 * @interface IntegrationDocumentType
 */
export interface IntegrationDocumentType {
    /**
     * Id of the document type
     * @type {number}
     * @memberof IntegrationDocumentType
     */
    'id'?: number;
    /**
     * Name of the government issued identification document type. Translations *will* be available depending on the locale.
     * @type {string}
     * @memberof IntegrationDocumentType
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface IntegrationErrorResponse
 */
export interface IntegrationErrorResponse {
    /**
     * Identify the type of error
     * @type {number}
     * @memberof IntegrationErrorResponse
     */
    'code'?: number;
    /**
     * Title of the error
     * @type {string}
     * @memberof IntegrationErrorResponse
     */
    'title'?: string;
    /**
     * Additional information about what the error means
     * @type {string}
     * @memberof IntegrationErrorResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface IntegrationIdentificationDocument
 */
export interface IntegrationIdentificationDocument {
    /**
     * 
     * @type {IntegrationDocumentType}
     * @memberof IntegrationIdentificationDocument
     */
    'type'?: IntegrationDocumentType;
    /**
     * Government issued personal identification.
     * @type {string}
     * @memberof IntegrationIdentificationDocument
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface IntegrationPhone
 */
export interface IntegrationPhone {
    /**
     * Official prefix number. It always begins by *+*
     * @type {string}
     * @memberof IntegrationPhone
     */
    'prefix'?: string;
    /**
     * Complete phone number without country prefix.
     * @type {string}
     * @memberof IntegrationPhone
     */
    'number'?: string;
}
/**
 * 
 * @export
 * @interface IntegrationTaxCode
 */
export interface IntegrationTaxCode {
    /**
     * Id of the Tax Code
     * @type {number}
     * @memberof IntegrationTaxCode
     */
    'id'?: number;
    /**
     * Name of the tax code selected by the customer. Translations *will* be available depending on the locale.
     * @type {string}
     * @memberof IntegrationTaxCode
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface IntegrationTaxRegime
 */
export interface IntegrationTaxRegime {
    /**
     * Id of the Tax Regime
     * @type {number}
     * @memberof IntegrationTaxRegime
     */
    'id'?: number;
    /**
     * Name of the tax regime selected by the customer. Translations *will* be available depending on the locale.
     * @type {string}
     * @memberof IntegrationTaxRegime
     */
    'name'?: string;
}
/**
 * Date configuration where the pickup point is opened or closed.
 * @export
 * @interface OpeningHours
 */
export interface OpeningHours {
    /**
     * Type of data
     * @type {string}
     * @memberof OpeningHours
     */
    'datatype'?: string;
    /**
     * A specific date that applies to this configuration.
     * @type {string}
     * @memberof OpeningHours
     */
    'date'?: string;
    /**
     * Day of the week that applies to this configuration.
     * @type {number}
     * @memberof OpeningHours
     */
    'weekDay'?: number;
    /**
     * List of ranges of opening hours that applies to this date or weekDay
     * @type {Array<OpeningHoursInterval>}
     * @memberof OpeningHours
     */
    'openingHoursInterval'?: Array<OpeningHoursInterval>;
    /**
     * 
     * @type {OpeningHoursException}
     * @memberof OpeningHours
     */
    'openingHoursException'?: OpeningHoursException;
}
/**
 * Indicates an exception for a wider opening or closing range
 * @export
 * @interface OpeningHoursException
 */
export interface OpeningHoursException {
    /**
     * Type of data
     * @type {string}
     * @memberof OpeningHoursException
     */
    'datatype'?: string;
    /**
     * Flag that indicates if it is an opening exception for a wider closing exception or just the opposite.
     * @type {boolean}
     * @memberof OpeningHoursException
     */
    'isClosed'?: boolean;
    /**
     * Description about the cause of this exception.
     * @type {string}
     * @memberof OpeningHoursException
     */
    'reason'?: string;
}
/**
 * Range of opening hours.
 * @export
 * @interface OpeningHoursInterval
 */
export interface OpeningHoursInterval {
    /**
     * Type of data
     * @type {string}
     * @memberof OpeningHoursInterval
     */
    'datatype'?: string;
    /**
     * Begin of the range.
     * @type {string}
     * @memberof OpeningHoursInterval
     */
    'openTime'?: string;
    /**
     * End of the range
     * @type {string}
     * @memberof OpeningHoursInterval
     */
    'closeTime'?: string;
}
/**
 * 
 * @export
 * @interface Phone
 */
export interface Phone {
    /**
     * Official prefix number. It always begins by *+*
     * @type {string}
     * @memberof Phone
     */
    'countryCode'?: string;
    /**
     * Complete phone number without country prefix.
     * @type {string}
     * @memberof Phone
     */
    'subscriberNumber'?: string;
    /**
     * It could take two values * mobile - Phone number comes from mobile network. * landing - Phone number comes from landline network. This type is being deprecated 
     * @type {string}
     * @memberof Phone
     */
    'phoneType'?: string;
}
/**
 * When the address is registered as a pickup point selected from available points offered by the system. This field is always missing when retrieving the address book because it is not possible to associate an address of type pickup point to it. These points are returned from external system when the user needs to select one.
 * @export
 * @interface PickUpPoint
 */
export interface PickUpPoint {
    /**
     * Pickup point id in TEC system.
     * @type {number}
     * @memberof PickUpPoint
     */
    'dropPointId'?: number;
    /**
     * External destination point id.
     * @type {string}
     * @memberof PickUpPoint
     */
    'destinationId'?: string;
    /**
     * External name that describes the destination point.
     * @type {string}
     * @memberof PickUpPoint
     */
    'destinationName'?: string;
    /**
     * External customer id associated to the *dropPointId*
     * @type {string}
     * @memberof PickUpPoint
     */
    'destinationCustomerId'?: string;
    /**
     * Latitude of GPS location point associated to destination point.
     * @type {number}
     * @memberof PickUpPoint
     */
    'destinationLatitude'?: number;
    /**
     * Longitude of GPS location point associated to destination point.
     * @type {number}
     * @memberof PickUpPoint
     */
    'destinationLongitude'?: number;
    /**
     * 
     * @type {Array<DropPointExtraParam>}
     * @memberof PickUpPoint
     */
    'extraParams'?: Array<DropPointExtraParam>;
    /**
     * 
     * @type {Array<OpeningHours>}
     * @memberof PickUpPoint
     */
    'openingHours'?: Array<OpeningHours>;
}
/**
 * Set of values that have to do with user privacy issues
 * @export
 * @interface PrivacyPolicyBundleRequest
 */
export interface PrivacyPolicyBundleRequest {
    /**
     * Flag that indicates that the user has accepted privacy policies.
     * @type {boolean}
     * @memberof PrivacyPolicyBundleRequest
     */
    'privatePolicy'?: boolean;
    /**
     * Flag that indicates that the user has accepted privacy policies about overseas transfers.
     * @type {boolean}
     * @memberof PrivacyPolicyBundleRequest
     */
    'overseasTransferPolicy'?: boolean;
    /**
     * Flag that indicates the user has accepted to be suscribed to newsletter.
     * @type {boolean}
     * @memberof PrivacyPolicyBundleRequest
     */
    'newsletter'?: boolean;
}
/**
 * 
 * @export
 * @interface RestError
 */
export interface RestError {
    /**
     * Identify the type of error
     * @type {number}
     * @memberof RestError
     */
    'code'?: number;
    /**
     * Information about the service which return the error
     * @type {string}
     * @memberof RestError
     */
    'service'?: string;
    /**
     * Additional information about what the error means
     * @type {string}
     * @memberof RestError
     */
    'description'?: string;
    /**
     * Action associated to the error
     * @type {number}
     * @memberof RestError
     */
    'action'?: number;
}
/**
 * 
 * @export
 * @interface SaveEvaluateAddressUserChoiceRequest
 */
export interface SaveEvaluateAddressUserChoiceRequest {
    /**
     * 
     * @type {UserChoice}
     * @memberof SaveEvaluateAddressUserChoiceRequest
     */
    'userChoice'?: UserChoice;
}


/**
 * 
 * @export
 * @interface SaveEvaluateAddressUserChoiceResponse
 */
export interface SaveEvaluateAddressUserChoiceResponse {
    /**
     * New address Id associated to address valiation metadata
     * @type {number}
     * @memberof SaveEvaluateAddressUserChoiceResponse
     */
    'addressId'?: number;
}
/**
 * Contains the choice made by the user when evaluating an address * VALID - The address introduced by the user was evaluated as OK and there is no suggestion. The user had nothing to choose * VALID_MANUAL - The address introduced by the user was evaluated as OK with suggestions, but the user choose the one introduced * VALID_SUGGESTED - The address introduced by the user was evaluated as OK with suggestions, and the user choose one of the suggested * VALID_AUTOMATIC - The address was automatically evaluated as OK by a job * INVALID_MANUAL - The address introduced by the user was evaluated as WRONG with suggestions, but the user choose the one introduced * INVALID_SUGGESTED - The address introduced by the user was evaluated as OK with suggestions, and the user choose one of the suggested * INVALID_AUTOMATIC - The address was automatically evaluated as WRONG by a job * NO_RESPONSE - The address could not have been evaluated or was invalid without suggestions. The user had nothing to choose 
 * @export
 * @enum {string}
 */

export const UserChoice = {
    Valid: 'VALID',
    ValidManual: 'VALID_MANUAL',
    ValidSuggested: 'VALID_SUGGESTED',
    ValidAutomatic: 'VALID_AUTOMATIC',
    InvalidManual: 'INVALID_MANUAL',
    InvalidSuggested: 'INVALID_SUGGESTED',
    InvalidAutomatic: 'INVALID_AUTOMATIC',
    NoResponse: 'NO_RESPONSE'
} as const;

export type UserChoice = typeof UserChoice[keyof typeof UserChoice];



/**
 * EvaluationApi - axios parameter creator
 * @export
 */
export const EvaluationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The address evaluation process is as follow:  - Retrieve the address associated with the identifier.  >- If the address does not exist, exit.  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
         * @summary Evaluates the correctness of the address provided by its identifier and can make suggestions of better addresses
         * @param {number} storeId The store identifier
         * @param {number} addressId The address identifier
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateAddressByIdWithSuggestions: async (storeId: number, addressId: number, languageId?: number, validations?: Array<AddressValidationType>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('evaluateAddressByIdWithSuggestions', 'storeId', storeId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('evaluateAddressByIdWithSuggestions', 'addressId', addressId)
            const localVarPath = `/itxrest/1/user/store/{storeId}/address/{addressId}/address-evaluation`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }

            if (validations) {
                localVarQueryParameter['validations'] = validations;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The address evaluation process is as follow  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
         * @summary Evaluates the correctness of the address provided and can make suggestions of better addresses
         * @param {number} storeId The store identifier
         * @param {EvaluateAddressRequest} evaluateAddressRequest Content used to validate the address
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateAddressWithSuggestions: async (storeId: number, evaluateAddressRequest: EvaluateAddressRequest, languageId?: number, validations?: Array<AddressValidationType>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('evaluateAddressWithSuggestions', 'storeId', storeId)
            // verify required parameter 'evaluateAddressRequest' is not null or undefined
            assertParamExists('evaluateAddressWithSuggestions', 'evaluateAddressRequest', evaluateAddressRequest)
            const localVarPath = `/itxrest/1/user/store/{storeId}/address-evaluation`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }

            if (validations) {
                localVarQueryParameter['validations'] = validations;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluateAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save address evaluation user choice by Address Id
         * @summary Save address evaluation user choice by Address Id
         * @param {number} storeId The store identifier
         * @param {number} addressId The address identifier
         * @param {SaveEvaluateAddressUserChoiceRequest} saveEvaluateAddressUserChoiceRequest Content used to indicate address evaluation pass mark
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluateAddressUserChoice: async (storeId: number, addressId: number, saveEvaluateAddressUserChoiceRequest: SaveEvaluateAddressUserChoiceRequest, languageId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('saveEvaluateAddressUserChoice', 'storeId', storeId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('saveEvaluateAddressUserChoice', 'addressId', addressId)
            // verify required parameter 'saveEvaluateAddressUserChoiceRequest' is not null or undefined
            assertParamExists('saveEvaluateAddressUserChoice', 'saveEvaluateAddressUserChoiceRequest', saveEvaluateAddressUserChoiceRequest)
            const localVarPath = `/itxrest/1/user/store/{storeId}/address/{addressId}/address-evaluation/user-choice`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveEvaluateAddressUserChoiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvaluationApi - functional programming interface
 * @export
 */
export const EvaluationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EvaluationApiAxiosParamCreator(configuration)
    return {
        /**
         * The address evaluation process is as follow:  - Retrieve the address associated with the identifier.  >- If the address does not exist, exit.  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
         * @summary Evaluates the correctness of the address provided by its identifier and can make suggestions of better addresses
         * @param {number} storeId The store identifier
         * @param {number} addressId The address identifier
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateAddressByIdWithSuggestions(storeId: number, addressId: number, languageId?: number, validations?: Array<AddressValidationType>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluateAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateAddressByIdWithSuggestions(storeId, addressId, languageId, validations, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The address evaluation process is as follow  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
         * @summary Evaluates the correctness of the address provided and can make suggestions of better addresses
         * @param {number} storeId The store identifier
         * @param {EvaluateAddressRequest} evaluateAddressRequest Content used to validate the address
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateAddressWithSuggestions(storeId: number, evaluateAddressRequest: EvaluateAddressRequest, languageId?: number, validations?: Array<AddressValidationType>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluateAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateAddressWithSuggestions(storeId, evaluateAddressRequest, languageId, validations, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Save address evaluation user choice by Address Id
         * @summary Save address evaluation user choice by Address Id
         * @param {number} storeId The store identifier
         * @param {number} addressId The address identifier
         * @param {SaveEvaluateAddressUserChoiceRequest} saveEvaluateAddressUserChoiceRequest Content used to indicate address evaluation pass mark
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEvaluateAddressUserChoice(storeId: number, addressId: number, saveEvaluateAddressUserChoiceRequest: SaveEvaluateAddressUserChoiceRequest, languageId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveEvaluateAddressUserChoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEvaluateAddressUserChoice(storeId, addressId, saveEvaluateAddressUserChoiceRequest, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EvaluationApi - factory interface
 * @export
 */
export const EvaluationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EvaluationApiFp(configuration)
    return {
        /**
         * The address evaluation process is as follow:  - Retrieve the address associated with the identifier.  >- If the address does not exist, exit.  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
         * @summary Evaluates the correctness of the address provided by its identifier and can make suggestions of better addresses
         * @param {number} storeId The store identifier
         * @param {number} addressId The address identifier
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateAddressByIdWithSuggestions(storeId: number, addressId: number, languageId?: number, validations?: Array<AddressValidationType>, options?: any): AxiosPromise<EvaluateAddressResponse> {
            return localVarFp.evaluateAddressByIdWithSuggestions(storeId, addressId, languageId, validations, options).then((request) => request(axios, basePath));
        },
        /**
         * The address evaluation process is as follow  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
         * @summary Evaluates the correctness of the address provided and can make suggestions of better addresses
         * @param {number} storeId The store identifier
         * @param {EvaluateAddressRequest} evaluateAddressRequest Content used to validate the address
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateAddressWithSuggestions(storeId: number, evaluateAddressRequest: EvaluateAddressRequest, languageId?: number, validations?: Array<AddressValidationType>, options?: any): AxiosPromise<EvaluateAddressResponse> {
            return localVarFp.evaluateAddressWithSuggestions(storeId, evaluateAddressRequest, languageId, validations, options).then((request) => request(axios, basePath));
        },
        /**
         * Save address evaluation user choice by Address Id
         * @summary Save address evaluation user choice by Address Id
         * @param {number} storeId The store identifier
         * @param {number} addressId The address identifier
         * @param {SaveEvaluateAddressUserChoiceRequest} saveEvaluateAddressUserChoiceRequest Content used to indicate address evaluation pass mark
         * @param {number} [languageId] The language identifier. By default will use -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvaluateAddressUserChoice(storeId: number, addressId: number, saveEvaluateAddressUserChoiceRequest: SaveEvaluateAddressUserChoiceRequest, languageId?: number, options?: any): AxiosPromise<SaveEvaluateAddressUserChoiceResponse> {
            return localVarFp.saveEvaluateAddressUserChoice(storeId, addressId, saveEvaluateAddressUserChoiceRequest, languageId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EvaluationApi - interface
 * @export
 * @interface EvaluationApi
 */
export interface EvaluationApiInterface {
    /**
     * The address evaluation process is as follow:  - Retrieve the address associated with the identifier.  >- If the address does not exist, exit.  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
     * @summary Evaluates the correctness of the address provided by its identifier and can make suggestions of better addresses
     * @param {number} storeId The store identifier
     * @param {number} addressId The address identifier
     * @param {number} [languageId] The language identifier. By default will use -1
     * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationApiInterface
     */
    evaluateAddressByIdWithSuggestions(storeId: number, addressId: number, languageId?: number, validations?: Array<AddressValidationType>, options?: AxiosRequestConfig): AxiosPromise<EvaluateAddressResponse>;

    /**
     * The address evaluation process is as follow  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
     * @summary Evaluates the correctness of the address provided and can make suggestions of better addresses
     * @param {number} storeId The store identifier
     * @param {EvaluateAddressRequest} evaluateAddressRequest Content used to validate the address
     * @param {number} [languageId] The language identifier. By default will use -1
     * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationApiInterface
     */
    evaluateAddressWithSuggestions(storeId: number, evaluateAddressRequest: EvaluateAddressRequest, languageId?: number, validations?: Array<AddressValidationType>, options?: AxiosRequestConfig): AxiosPromise<EvaluateAddressResponse>;

    /**
     * Save address evaluation user choice by Address Id
     * @summary Save address evaluation user choice by Address Id
     * @param {number} storeId The store identifier
     * @param {number} addressId The address identifier
     * @param {SaveEvaluateAddressUserChoiceRequest} saveEvaluateAddressUserChoiceRequest Content used to indicate address evaluation pass mark
     * @param {number} [languageId] The language identifier. By default will use -1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationApiInterface
     */
    saveEvaluateAddressUserChoice(storeId: number, addressId: number, saveEvaluateAddressUserChoiceRequest: SaveEvaluateAddressUserChoiceRequest, languageId?: number, options?: AxiosRequestConfig): AxiosPromise<SaveEvaluateAddressUserChoiceResponse>;

}

/**
 * EvaluationApi - object-oriented interface
 * @export
 * @class EvaluationApi
 * @extends {BaseAPI}
 */
export class EvaluationApi extends BaseAPI implements EvaluationApiInterface {
    /**
     * The address evaluation process is as follow:  - Retrieve the address associated with the identifier.  >- If the address does not exist, exit.  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
     * @summary Evaluates the correctness of the address provided by its identifier and can make suggestions of better addresses
     * @param {number} storeId The store identifier
     * @param {number} addressId The address identifier
     * @param {number} [languageId] The language identifier. By default will use -1
     * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationApi
     */
    public evaluateAddressByIdWithSuggestions(storeId: number, addressId: number, languageId?: number, validations?: Array<AddressValidationType>, options?: AxiosRequestConfig) {
        return EvaluationApiFp(this.configuration).evaluateAddressByIdWithSuggestions(storeId, addressId, languageId, validations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The address evaluation process is as follow  - If no value is provided to validations parameter, the following validations will be performed:  >- Validate current mandatory restrictions (required fields...), that is, the address could be stored.   >>- If the address is not ok, exit.  >- Do specific store validations (vertex) if needed.  >>- If the address is not ok, exit.  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - If TRANSPORT value is provided to validations parameter, the following validations will be performed:  >- Check the address using the transport service (may be valid or not, but it is not binding).  >>- If any address is suggested, validate all of them in order to discard the ones that may not be usable  - Finally returns the pass mark and the available valid suggestions 
     * @summary Evaluates the correctness of the address provided and can make suggestions of better addresses
     * @param {number} storeId The store identifier
     * @param {EvaluateAddressRequest} evaluateAddressRequest Content used to validate the address
     * @param {number} [languageId] The language identifier. By default will use -1
     * @param {Array<AddressValidationType>} [validations] The validations to perform on the address. If no value is provided, all validations will be passed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationApi
     */
    public evaluateAddressWithSuggestions(storeId: number, evaluateAddressRequest: EvaluateAddressRequest, languageId?: number, validations?: Array<AddressValidationType>, options?: AxiosRequestConfig) {
        return EvaluationApiFp(this.configuration).evaluateAddressWithSuggestions(storeId, evaluateAddressRequest, languageId, validations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save address evaluation user choice by Address Id
     * @summary Save address evaluation user choice by Address Id
     * @param {number} storeId The store identifier
     * @param {number} addressId The address identifier
     * @param {SaveEvaluateAddressUserChoiceRequest} saveEvaluateAddressUserChoiceRequest Content used to indicate address evaluation pass mark
     * @param {number} [languageId] The language identifier. By default will use -1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluationApi
     */
    public saveEvaluateAddressUserChoice(storeId: number, addressId: number, saveEvaluateAddressUserChoiceRequest: SaveEvaluateAddressUserChoiceRequest, languageId?: number, options?: AxiosRequestConfig) {
        return EvaluationApiFp(this.configuration).saveEvaluateAddressUserChoice(storeId, addressId, saveEvaluateAddressUserChoiceRequest, languageId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntegrationApi - axios parameter creator
 * @export
 */
export const IntegrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This is a maintenance API. An address shall be modified by providing its id (toAddressId) by another address which shall also be provided its id (fromAddressId). If the id of the address to be modified (toAddressId) is not provided, a new address shall be created. The modified address shall be synchronised with wcs.
         * @summary Updates or creates an address with data from another address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {CopyAddressFromRequest} copyAddressFromRequest toAddressId &gt;- address to be changed. fromAddressId &gt;- address that will provide the data to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyAddressFrom: async (storeId: number, userId: number, copyAddressFromRequest: CopyAddressFromRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('copyAddressFrom', 'storeId', storeId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('copyAddressFrom', 'userId', userId)
            // verify required parameter 'copyAddressFromRequest' is not null or undefined
            assertParamExists('copyAddressFrom', 'copyAddressFromRequest', copyAddressFromRequest)
            const localVarPath = `/itxrest/1/private/integration/store/{storeId}/user/{userId}/address/copy`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyAddressFromRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
         * @summary Gets a billing address for the given id, updates the address without making any changes and sends the data to wcs and sends a WCS synchronization event with the given address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} addressId identifier of the billing address (snapshotId) to be updated and synchronized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyBillingAddress: async (storeId: number, userId: number, addressId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('copyBillingAddress', 'storeId', storeId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('copyBillingAddress', 'userId', userId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('copyBillingAddress', 'addressId', addressId)
            const localVarPath = `/itxrest/1/private/integration/store/{storeId}/user/{userId}/billing-address/{addressId}/copy`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or updates an address for a user in given store.<br>Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Creates or updates an address for a user.
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateIntegrationUserAddress: async (storeId: number, userId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('createOrUpdateIntegrationUserAddress', 'storeId', storeId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createOrUpdateIntegrationUserAddress', 'userId', userId)
            // verify required parameter 'addUpdateAddressRequest' is not null or undefined
            assertParamExists('createOrUpdateIntegrationUserAddress', 'addUpdateAddressRequest', addUpdateAddressRequest)
            const localVarPath = `/itxrest/1/private/integration/store/{storeId}/user/{userId}/address`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUpdateAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the reference, most updated address, for a given addressId. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Most recent version of a user addresses.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address
         * @param {number} userId the id of the user
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: async (storeId: number, addressId: number, userId: number, languageId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getAddress', 'storeId', storeId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('getAddress', 'addressId', addressId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAddress', 'userId', userId)
            const localVarPath = `/itxrest/1/private/integration/store/{storeId}/address/{addressId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }

            if (userId != null) {
                localVarHeaderParameter['userId'] = typeof userId === 'string' 
                    ? userId 
                    : JSON.stringify(userId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an address by id regardless of the version, if it is the most updated or not. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Returns an address by id regardless of the version.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address. Corresponding to snapshot id.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressSnapshot: async (storeId: number, addressId: number, languageId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getAddressSnapshot', 'storeId', storeId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('getAddressSnapshot', 'addressId', addressId)
            const localVarPath = `/itxrest/1/private/integration/store/{storeId}/address/snapshot/{addressId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Last recent billing address corresponding to an user in a given store. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Billing address for a user.
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBillingAddress: async (storeId: number, userId: number, languageId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getUserBillingAddress', 'storeId', storeId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserBillingAddress', 'userId', userId)
            const localVarPath = `/itxrest/1/private/integration/store/{storeId}/user/{userId}/address/billing`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
         * @summary Sends a WCS synchronization event with the given address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} addressId identifier of the address to be synchronized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddressEventToWCS: async (storeId: number, userId: number, addressId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('sendAddressEventToWCS', 'storeId', storeId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendAddressEventToWCS', 'userId', userId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('sendAddressEventToWCS', 'addressId', addressId)
            const localVarPath = `/itxrest/1/private/integration/store/{storeId}/user/{userId}/address/{addressId}/wcs-event`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationApi - functional programming interface
 * @export
 */
export const IntegrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationApiAxiosParamCreator(configuration)
    return {
        /**
         * This is a maintenance API. An address shall be modified by providing its id (toAddressId) by another address which shall also be provided its id (fromAddressId). If the id of the address to be modified (toAddressId) is not provided, a new address shall be created. The modified address shall be synchronised with wcs.
         * @summary Updates or creates an address with data from another address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {CopyAddressFromRequest} copyAddressFromRequest toAddressId &gt;- address to be changed. fromAddressId &gt;- address that will provide the data to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyAddressFrom(storeId: number, userId: number, copyAddressFromRequest: CopyAddressFromRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopyAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyAddressFrom(storeId, userId, copyAddressFromRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
         * @summary Gets a billing address for the given id, updates the address without making any changes and sends the data to wcs and sends a WCS synchronization event with the given address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} addressId identifier of the billing address (snapshotId) to be updated and synchronized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyBillingAddress(storeId: number, userId: number, addressId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopyAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyBillingAddress(storeId, userId, addressId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates or updates an address for a user in given store.<br>Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Creates or updates an address for a user.
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateIntegrationUserAddress(storeId: number, userId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddUpdateAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateIntegrationUserAddress(storeId, userId, addUpdateAddressRequest, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the reference, most updated address, for a given addressId. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Most recent version of a user addresses.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address
         * @param {number} userId the id of the user
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddress(storeId: number, addressId: number, userId: number, languageId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddress(storeId, addressId, userId, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns an address by id regardless of the version, if it is the most updated or not. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Returns an address by id regardless of the version.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address. Corresponding to snapshot id.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddressSnapshot(storeId: number, addressId: number, languageId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressSnapshot(storeId, addressId, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Last recent billing address corresponding to an user in a given store. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Billing address for a user.
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserBillingAddress(storeId: number, userId: number, languageId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserBillingAddress(storeId, userId, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
         * @summary Sends a WCS synchronization event with the given address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} addressId identifier of the address to be synchronized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAddressEventToWCS(storeId: number, userId: number, addressId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAddressEventToWCS(storeId, userId, addressId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationApi - factory interface
 * @export
 */
export const IntegrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationApiFp(configuration)
    return {
        /**
         * This is a maintenance API. An address shall be modified by providing its id (toAddressId) by another address which shall also be provided its id (fromAddressId). If the id of the address to be modified (toAddressId) is not provided, a new address shall be created. The modified address shall be synchronised with wcs.
         * @summary Updates or creates an address with data from another address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {CopyAddressFromRequest} copyAddressFromRequest toAddressId &gt;- address to be changed. fromAddressId &gt;- address that will provide the data to be modified.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyAddressFrom(storeId: number, userId: number, copyAddressFromRequest: CopyAddressFromRequest, options?: any): AxiosPromise<CopyAddressResponse> {
            return localVarFp.copyAddressFrom(storeId, userId, copyAddressFromRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
         * @summary Gets a billing address for the given id, updates the address without making any changes and sends the data to wcs and sends a WCS synchronization event with the given address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} addressId identifier of the billing address (snapshotId) to be updated and synchronized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyBillingAddress(storeId: number, userId: number, addressId: number, options?: any): AxiosPromise<CopyAddressResponse> {
            return localVarFp.copyBillingAddress(storeId, userId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or updates an address for a user in given store.<br>Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Creates or updates an address for a user.
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateIntegrationUserAddress(storeId: number, userId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options?: any): AxiosPromise<AddUpdateAddressResponse> {
            return localVarFp.createOrUpdateIntegrationUserAddress(storeId, userId, addUpdateAddressRequest, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the reference, most updated address, for a given addressId. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Most recent version of a user addresses.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address
         * @param {number} userId the id of the user
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress(storeId: number, addressId: number, userId: number, languageId?: number, options?: any): AxiosPromise<IntegrationAddress> {
            return localVarFp.getAddress(storeId, addressId, userId, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an address by id regardless of the version, if it is the most updated or not. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Returns an address by id regardless of the version.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address. Corresponding to snapshot id.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressSnapshot(storeId: number, addressId: number, languageId?: number, options?: any): AxiosPromise<IntegrationAddress> {
            return localVarFp.getAddressSnapshot(storeId, addressId, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Last recent billing address corresponding to an user in a given store. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary Billing address for a user.
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBillingAddress(storeId: number, userId: number, languageId?: number, options?: any): AxiosPromise<IntegrationAddress> {
            return localVarFp.getUserBillingAddress(storeId, userId, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
         * @summary Sends a WCS synchronization event with the given address
         * @param {number} storeId the id of the store.
         * @param {number} userId the id of the user
         * @param {number} addressId identifier of the address to be synchronized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddressEventToWCS(storeId: number, userId: number, addressId: number, options?: any): AxiosPromise<void> {
            return localVarFp.sendAddressEventToWCS(storeId, userId, addressId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationApi - interface
 * @export
 * @interface IntegrationApi
 */
export interface IntegrationApiInterface {
    /**
     * This is a maintenance API. An address shall be modified by providing its id (toAddressId) by another address which shall also be provided its id (fromAddressId). If the id of the address to be modified (toAddressId) is not provided, a new address shall be created. The modified address shall be synchronised with wcs.
     * @summary Updates or creates an address with data from another address
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {CopyAddressFromRequest} copyAddressFromRequest toAddressId &gt;- address to be changed. fromAddressId &gt;- address that will provide the data to be modified.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiInterface
     */
    copyAddressFrom(storeId: number, userId: number, copyAddressFromRequest: CopyAddressFromRequest, options?: AxiosRequestConfig): AxiosPromise<CopyAddressResponse>;

    /**
     * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
     * @summary Gets a billing address for the given id, updates the address without making any changes and sends the data to wcs and sends a WCS synchronization event with the given address
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {number} addressId identifier of the billing address (snapshotId) to be updated and synchronized
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiInterface
     */
    copyBillingAddress(storeId: number, userId: number, addressId: number, options?: AxiosRequestConfig): AxiosPromise<CopyAddressResponse>;

    /**
     * Creates or updates an address for a user in given store.<br>Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary Creates or updates an address for a user.
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiInterface
     */
    createOrUpdateIntegrationUserAddress(storeId: number, userId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options?: AxiosRequestConfig): AxiosPromise<AddUpdateAddressResponse>;

    /**
     * Gets the reference, most updated address, for a given addressId. Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary Most recent version of a user addresses.
     * @param {number} storeId the id of the store.
     * @param {number} addressId the id of the address
     * @param {number} userId the id of the user
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiInterface
     */
    getAddress(storeId: number, addressId: number, userId: number, languageId?: number, options?: AxiosRequestConfig): AxiosPromise<IntegrationAddress>;

    /**
     * Returns an address by id regardless of the version, if it is the most updated or not. Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary Returns an address by id regardless of the version.
     * @param {number} storeId the id of the store.
     * @param {number} addressId the id of the address. Corresponding to snapshot id.
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiInterface
     */
    getAddressSnapshot(storeId: number, addressId: number, languageId?: number, options?: AxiosRequestConfig): AxiosPromise<IntegrationAddress>;

    /**
     * Last recent billing address corresponding to an user in a given store. Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary Billing address for a user.
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiInterface
     */
    getUserBillingAddress(storeId: number, userId: number, languageId?: number, options?: AxiosRequestConfig): AxiosPromise<IntegrationAddress>;

    /**
     * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
     * @summary Sends a WCS synchronization event with the given address
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {number} addressId identifier of the address to be synchronized
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApiInterface
     */
    sendAddressEventToWCS(storeId: number, userId: number, addressId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * IntegrationApi - object-oriented interface
 * @export
 * @class IntegrationApi
 * @extends {BaseAPI}
 */
export class IntegrationApi extends BaseAPI implements IntegrationApiInterface {
    /**
     * This is a maintenance API. An address shall be modified by providing its id (toAddressId) by another address which shall also be provided its id (fromAddressId). If the id of the address to be modified (toAddressId) is not provided, a new address shall be created. The modified address shall be synchronised with wcs.
     * @summary Updates or creates an address with data from another address
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {CopyAddressFromRequest} copyAddressFromRequest toAddressId &gt;- address to be changed. fromAddressId &gt;- address that will provide the data to be modified.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public copyAddressFrom(storeId: number, userId: number, copyAddressFromRequest: CopyAddressFromRequest, options?: AxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).copyAddressFrom(storeId, userId, copyAddressFromRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
     * @summary Gets a billing address for the given id, updates the address without making any changes and sends the data to wcs and sends a WCS synchronization event with the given address
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {number} addressId identifier of the billing address (snapshotId) to be updated and synchronized
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public copyBillingAddress(storeId: number, userId: number, addressId: number, options?: AxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).copyBillingAddress(storeId, userId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or updates an address for a user in given store.<br>Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary Creates or updates an address for a user.
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public createOrUpdateIntegrationUserAddress(storeId: number, userId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options?: AxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).createOrUpdateIntegrationUserAddress(storeId, userId, addUpdateAddressRequest, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the reference, most updated address, for a given addressId. Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary Most recent version of a user addresses.
     * @param {number} storeId the id of the store.
     * @param {number} addressId the id of the address
     * @param {number} userId the id of the user
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public getAddress(storeId: number, addressId: number, userId: number, languageId?: number, options?: AxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).getAddress(storeId, addressId, userId, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an address by id regardless of the version, if it is the most updated or not. Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary Returns an address by id regardless of the version.
     * @param {number} storeId the id of the store.
     * @param {number} addressId the id of the address. Corresponding to snapshot id.
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public getAddressSnapshot(storeId: number, addressId: number, languageId?: number, options?: AxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).getAddressSnapshot(storeId, addressId, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Last recent billing address corresponding to an user in a given store. Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary Billing address for a user.
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public getUserBillingAddress(storeId: number, userId: number, languageId?: number, options?: AxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).getUserBillingAddress(storeId, userId, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is a maintenance API. The purpose of it is help to fix synchronization problems between Address service and WCS.
     * @summary Sends a WCS synchronization event with the given address
     * @param {number} storeId the id of the store.
     * @param {number} userId the id of the user
     * @param {number} addressId identifier of the address to be synchronized
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public sendAddressEventToWCS(storeId: number, userId: number, addressId: number, options?: AxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).sendAddressEventToWCS(storeId, userId, addressId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation allows users registering or updating an address. There are several address whose validations and mandatory depends on the store address configuration. Use the operation *_/itxrest/1/store/{storeId}/config/address/_* to review that configuration. There are some fields configurations which are not dynamically configured but preset for each store.
         * @summary Add or update a billing and/or shipping address to an existing user.
         * @param {number} storeId the id of the store.
         * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUpdateAddress: async (storeId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('addUpdateAddress', 'storeId', storeId)
            // verify required parameter 'addUpdateAddressRequest' is not null or undefined
            assertParamExists('addUpdateAddress', 'addUpdateAddressRequest', addUpdateAddressRequest)
            const localVarPath = `/itxrest/2/user/store/{storeId}/address`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUpdateAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set of address that the user has registered, for example, when registering the account, placing orders or modifying the profile information. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary List all addresses of the user for a given store
         * @param {number} storeId the id of the store.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBook: async (storeId: number, languageId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('addressBook', 'storeId', storeId)
            const localVarPath = `/itxrest/1/user/store/{storeId}/address`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * After deleting the address, if there was a pending order associated with it, the association is also deleted. Deleting the billing address is not allowed.
         * @summary Delete a previously address registered by a user.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address to be deleted.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress: async (storeId: number, addressId: number, languageId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteAddress', 'storeId', storeId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('deleteAddress', 'addressId', addressId)
            const localVarPath = `/itxrest/1/user/store/{storeId}/address/{addressId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WCS-WCTrustedToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCTrustedToken", configuration)

            // authentication WCS-UserId required
            await setApiKeyToObject(localVarHeaderParameter, "userId", configuration)

            // authentication WCS-WCToken required
            await setApiKeyToObject(localVarHeaderParameter, "WCToken", configuration)

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * This operation allows users registering or updating an address. There are several address whose validations and mandatory depends on the store address configuration. Use the operation *_/itxrest/1/store/{storeId}/config/address/_* to review that configuration. There are some fields configurations which are not dynamically configured but preset for each store.
         * @summary Add or update a billing and/or shipping address to an existing user.
         * @param {number} storeId the id of the store.
         * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUpdateAddress(storeId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddUpdateAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUpdateAddress(storeId, addUpdateAddressRequest, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set of address that the user has registered, for example, when registering the account, placing orders or modifying the profile information. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary List all addresses of the user for a given store
         * @param {number} storeId the id of the store.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressBook(storeId: number, languageId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressBookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressBook(storeId, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * After deleting the address, if there was a pending order associated with it, the association is also deleted. Deleting the billing address is not allowed.
         * @summary Delete a previously address registered by a user.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address to be deleted.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddress(storeId: number, addressId: number, languageId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAddress(storeId, addressId, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * This operation allows users registering or updating an address. There are several address whose validations and mandatory depends on the store address configuration. Use the operation *_/itxrest/1/store/{storeId}/config/address/_* to review that configuration. There are some fields configurations which are not dynamically configured but preset for each store.
         * @summary Add or update a billing and/or shipping address to an existing user.
         * @param {number} storeId the id of the store.
         * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUpdateAddress(storeId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options?: any): AxiosPromise<AddUpdateAddressResponse> {
            return localVarFp.addUpdateAddress(storeId, addUpdateAddressRequest, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set of address that the user has registered, for example, when registering the account, placing orders or modifying the profile information. Depending on the *languageId* parameter, some entities in the response could be translated.
         * @summary List all addresses of the user for a given store
         * @param {number} storeId the id of the store.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBook(storeId: number, languageId?: number, options?: any): AxiosPromise<AddressBookResponse> {
            return localVarFp.addressBook(storeId, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * After deleting the address, if there was a pending order associated with it, the association is also deleted. Deleting the billing address is not allowed.
         * @summary Delete a previously address registered by a user.
         * @param {number} storeId the id of the store.
         * @param {number} addressId the id of the address to be deleted.
         * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress(storeId: number, addressId: number, languageId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAddress(storeId, addressId, languageId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - interface
 * @export
 * @interface UserApi
 */
export interface UserApiInterface {
    /**
     * This operation allows users registering or updating an address. There are several address whose validations and mandatory depends on the store address configuration. Use the operation *_/itxrest/1/store/{storeId}/config/address/_* to review that configuration. There are some fields configurations which are not dynamically configured but preset for each store.
     * @summary Add or update a billing and/or shipping address to an existing user.
     * @param {number} storeId the id of the store.
     * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    addUpdateAddress(storeId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options?: AxiosRequestConfig): AxiosPromise<AddUpdateAddressResponse>;

    /**
     * Set of address that the user has registered, for example, when registering the account, placing orders or modifying the profile information. Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary List all addresses of the user for a given store
     * @param {number} storeId the id of the store.
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    addressBook(storeId: number, languageId?: number, options?: AxiosRequestConfig): AxiosPromise<AddressBookResponse>;

    /**
     * After deleting the address, if there was a pending order associated with it, the association is also deleted. Deleting the billing address is not allowed.
     * @summary Delete a previously address registered by a user.
     * @param {number} storeId the id of the store.
     * @param {number} addressId the id of the address to be deleted.
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApiInterface
     */
    deleteAddress(storeId: number, addressId: number, languageId?: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI implements UserApiInterface {
    /**
     * This operation allows users registering or updating an address. There are several address whose validations and mandatory depends on the store address configuration. Use the operation *_/itxrest/1/store/{storeId}/config/address/_* to review that configuration. There are some fields configurations which are not dynamically configured but preset for each store.
     * @summary Add or update a billing and/or shipping address to an existing user.
     * @param {number} storeId the id of the store.
     * @param {AddUpdateAddressRequest} addUpdateAddressRequest Content used to register a new address or update an existing one
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public addUpdateAddress(storeId: number, addUpdateAddressRequest: AddUpdateAddressRequest, languageId?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).addUpdateAddress(storeId, addUpdateAddressRequest, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set of address that the user has registered, for example, when registering the account, placing orders or modifying the profile information. Depending on the *languageId* parameter, some entities in the response could be translated.
     * @summary List all addresses of the user for a given store
     * @param {number} storeId the id of the store.
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public addressBook(storeId: number, languageId?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).addressBook(storeId, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * After deleting the address, if there was a pending order associated with it, the association is also deleted. Deleting the billing address is not allowed.
     * @summary Delete a previously address registered by a user.
     * @param {number} storeId the id of the store.
     * @param {number} addressId the id of the address to be deleted.
     * @param {number} [languageId] language identifier. By default will use -1 (en_GB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteAddress(storeId: number, addressId: number, languageId?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteAddress(storeId, addressId, languageId, options).then((request) => request(this.axios, this.basePath));
    }
}


